import * as React from 'react'
import { useInView } from '../../../utils/hooks/hooks/useInView'
import { Image, ImageBase, ImageOptions } from '../../../utils/images'
import { advertisementBlockStyle } from '../../../utils/style'
import { getClassName } from '../../../utils/utils'
import { InviewProps } from './blocksState'

export type AdvertisementBlock = {
  index: number
  image: ImageBase & ImageOptions
  url: string
  inview?: InviewProps,
}

export type AdvertismentBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  blockWrapper: string
  linkContainer: string
}>

export function AdvertisementBlockLayout(props: AdvertisementBlock) {
  const { inview, index, image, url } = props
  const classes = advertisementBlockStyle
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("AdvertisementBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')

  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(advertisementBlockStyle, 'innerClassName', 'py-5')}>
        <div className={getClassName(advertisementBlockStyle, 'blockWrapper')}>
          <a href={url} target="_blank" rel="noopener noreferrer" className={getClassName(advertisementBlockStyle, 'linkContainer')}>
            <Image {...image} classNames={{ image: "" }} />
          </a>
        </div>
      </div>
    </section>
  )

}
